export default {
  state: {
    // cssCode: '#318ff5', // 主色值
    message: 'Hello!',
    require_checked_active_list: [], // 必选包选中状态
    require_open_active_list: [], // 必选包检查项打开状态
    optional_checked_active_list: [], // 可选包选中状态
    optional_open_active_list: [], // 可选包检查项打开状态
    requireBags: [], // 选中的必选包
    optionalBags: [], // 选中的可选包
    tempMutexAddGoodsCodes: [], // 临时的互斥加项包数组
    cacheRequireCodes: [], // 缓存加项包
    totalPrice: 0,
    customerServiceNumber: '', // 客服电话
    logoUrl: '', // logo
    protocolName: '', // 协议名字
    protocolImgList: [], // 协议内容
    checkSignInfo: {}, // 验签信息
    isLogin: false,
    maskMobile: '',
    szMemberCode: '',
    GOODS_D: {}, // 移动端套餐数据
    REQUIRED_ADD_D: {}, // 移动端必选包数据
    OPTIONAL_ADD_D: {} // 移动端可选包数据
  },
  mutations: {
    setMessage (state, message) {
      state.message = message
    },
    setRequireCheckedActiveList (state, require_checked_active_list) {
      state.require_checked_active_list = require_checked_active_list
    },
    setRequireOpenActiveList (state, require_open_active_list) {
      state.require_open_active_list = require_open_active_list
    },
    setOptionalCheckedActiveList (state, optional_checked_active_list) {
      state.optional_checked_active_list = optional_checked_active_list
    },
    setOptionalOpenActiveList (state, optional_open_active_list) {
      state.optional_open_active_list = optional_open_active_list
    },
    setRequireBags (state, requireBags) {
      state.requireBags = requireBags
    },
    setOptionalBags (state, optionalBags) {
      state.optionalBags = optionalBags
    },
    setTempMutexAddGoodsCodes (state, tempMutexAddGoodsCodes) {
      state.tempMutexAddGoodsCodes = tempMutexAddGoodsCodes
    }, 
    setCacheRequireCodes (state, cacheRequireCodes) {
      state.cacheRequireCodes = cacheRequireCodes
    },
    setTotalPrice (state, totalPrice) {
      state.totalPrice = totalPrice
    },
    setCustomerServiceNumber (state, customerServiceNumber) {
      state.customerServiceNumber = customerServiceNumber
    },
    setLogoUrl (state, logoUrl) {
      state.logoUrl = logoUrl
    },
    setProtocolName (state, protocolName) {
      state.protocolName = protocolName
    },
    setProtocolImgList (state, protocolImgList) {
      state.protocolImgList = protocolImgList
    },
    setCheckSignInfo (state, checkSignInfo) {
      state.checkSignInfo = checkSignInfo
    },
    setIsLogin (state, isLogin) {
      state.isLogin = isLogin
    },
    setMaskMobile (state, maskMobile) {
      state.maskMobile = maskMobile
    },
    setSzMemberCode (state, szMemberCode) {
      state.szMemberCode = szMemberCode
    },
    setGOODS_D (state, GOODS_D) {
      state.GOODS_D = GOODS_D
    },
    setREQUIRED_ADD_D (state, REQUIRED_ADD_D) {
      state.REQUIRED_ADD_D = REQUIRED_ADD_D
    },
    setOPTIONAL_ADD_D (state, OPTIONAL_ADD_D) {
      state.OPTIONAL_ADD_D = OPTIONAL_ADD_D
    }
  },
  getters: {},
  actions: {}
}
